import _getInstanceName from '@/utils/getInstanceName/index.mjs';

import models from '@/models/index.mjs';

export default function getInstanceName(obj) {
  return _getInstanceName(obj, models);
}
